<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    ></loading>
    <!--<tabs :fullWidth="true" >-->
      <tab name="Appearance" :selected="true">
      </tab>
      <!--<tab name="Analytics"> </tab>-->
      <!--<tab name="Settings"> </tab>-->
   <!--</tabs>-->
    
    <div class="container-fluid container--no-margin">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-lg-12">
          <div class="content">
            <div class="container-fluid container--no-margin">
              <div class="row">
                <div
                  class="col-xs-12 col-sm-12 col-lg-4 container--no-margin"
                  style="background-color: #fff;"
                >
                  <div class="page-editor--side">
                    <div>
                      <div
                        class="page-editor--side-item-content page-editor--side-item-content-active page-editor--side-item-content-active-top"
                      >
                        <div class="page-info--wrapper">
                          <div class="page--title">
                            {{ page.name }}
                          </div>
                          <div class="page--link">
                            <div v-if="page.enabled" class="page--status-on"></div>
                            <div v-else class="page--status-off"></div>
                            <div class="page--url">
                              <a
                                :href="
                                  'https://remixinbox.com/' + page.customUrl
                                "
                                target="_blank"
                              >
                                remixinbox.com/{{ page.customUrl
                                }}<svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  height="11px"
                                  stroke="currentColor"
                                  stroke-width="2.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-external-link"
                                >
                                  <path
                                    d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                  ></path>
                                  <polyline
                                    points="15 3 21 3 21 9"
                                  ></polyline>
                                  <line
                                    x1="10"
                                    y1="14"
                                    x2="21"
                                    y2="3"
                                  ></line></svg
                              ></a>
                            </div>
                          </div>
                        </div>
                        <div class="switch--wrapper">
                          <input
                            id="checkbox"
                            type="checkbox"
                            class="checkbox"
                            v-model="editted.enabled"
                          />
                          <label for="checkbox" class="switch">
                            <span class="switch__circle">
                              <span class="switch__circle-inner"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        class="page-editor--side-item"
                        v-on:click="expand($event)"
                      >
                        Information
                        <div class="chevron">
                          <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="page-editor--side-item-content">
                        <div class="page-editor--label">Page Title</div>
                        <input
                          type="text"
                          placeholder="Page Title"
                          v-model="editted.title"
                          name="title"
                          class="input--text email login--input-bottom"
                        />
                        <div class="page-editor--label">Description</div>
                        <textarea
                          type="text"
                          placeholder="Description"
                          name="title"
                          v-model="editted.description"
                          class="input--text email login--input-bottom input--textarea"
                        ></textarea>
                      </div>
                    </div>
                    <div>
                      <div
                        class="page-editor--side-item"
                        v-on:click="expand($event)"
                      >
                        Colors
                        <div class="chevron">
                          <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="page-editor--side-item-content">
                        <div class="page-editor--label">Primary Color</div>
                        <picker v-model="editted.primaryColor"></picker>
                        <div class="page-editor--label">
                          Secondary Color
                        </div>
                        <picker v-model="editted.secondaryColor"></picker>
                        <div class="page-editor--label">Text Color</div>
                        <picker
                          v-on:change="test($event)"
                          v-model="editted.textColor"
                        ></picker>
                      </div>
                    </div>
                    <div>
                      <div
                        class="page-editor--side-item"
                        v-on:click="expand($event)"
                      >
                        Branding
                        <div class="chevron">
                          <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="page-editor--side-item-content">
                        <div class="page-editor--label">Logo</div>
                        <div
                          class="page-editor--logo"
                          id="preview--logo"
                          v-bind:style="{
                            'background-image':
                              'url(' + editted.logoUrl + ')',
                          }"
                        ></div>
                       <input type="file" class="input--file" @change="changeAssets($event, 'logo')" accept="image/*" id="file-logo">
                        <br>
                        <div class="page-editor--label">Background</div>
                        <div
                          class="page-editor--background"
                          id="preview--background"
                          v-bind:style="{
                            'background-image':
                              'url(' + editted.backgroundUrl + ')',
                          }"
                        ></div>
                        <input type="file" class="input--file" @change="changeAssets($event, 'background')" accept="image/*" id="file-background">
                      </div>
                    </div>
                    <div>
                      <div
                        class="page-editor--side-item"
                        v-on:click="expand($event)"
                      >
                        Contest Settings
                        <div class="chevron">
                          <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="page-editor--side-item-content">
                        <div class="page-editor--label">Start Date</div>
                        <Datepicker  :monday-first="true" :disabledDates="disabledDatesOpen" v-model="editted.startDate"></Datepicker>
                          <br />
                        <div class="page-editor--label">Ending Date</div>
                        <Datepicker  :monday-first="true" v-model="editted.endDate"></Datepicker>
                          <br />
                       <div class="page-editor--label">Files</div>
                          <input
                          type="text"
                          placeholder="For example: Dropbox, Google Drive"
                          v-model="editted.trackStems"
                          name="title"
                          required
                          class="input--text email login--input-bottom"
                          />
                      </div>
                      
                    </div>
                    <div>
                      <div
                        class="page-editor--side-item"
                        v-on:click="expand($event)"
                      >
                        Track
                        <div class="chevron">
                          <svg
                            style="width: 24px; height: 24px"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                            />
                          </svg>
                        </div>
                      </div>
                      <div class="page-editor--side-item-content">
                        <div class="page-editor--label">Artist</div>
                        <input
                        type="text"
                        placeholder="Name of the original artist"
                        v-model="editted.trackArtist"
                        name="title"
                        class="input--text email login--input-bottom"
                        />
                          <br />
                        <div class="page-editor--label">Track Name</div>
                        <input
                        type="text"
                        placeholder="Original track name"
                        v-model="editted.trackName"
                        name="title"
                        class="input--text email login--input-bottom"
                        />
                          <br />
                          <div class="page-editor--label">Original Track Link</div>
                          <input
                          type="text"
                          placeholder="For example: Soundcloud, Spotify"
                          v-model="editted.trackLink"
                          name="title"
                          class="input--text email login--input-bottom"
                          />
                      </div>
                      
                    </div>
                    <div>
                      <div
                        class="page-editor--side-item"
                        v-on:click="expand($event)"
                      >
                        <div
                        class="btn page-editor--publish"
                        @click="publish()" style="position: relative;"
                      >
                        Publish
                      </div>
                      
                      </div>
                
                    </div>
                  </div>
                </div>
                <div
                  class="col-xs-12 col-sm-12 col-lg-8 container--no-margin"
                >
                  <div  style="max-height: 91.5vh; overflow-y:scroll; ">
                    <div class="page--wrapper" v-bind:style="{ 'background-image': 'url(' + editted.backgroundUrl + ')',}"></div>
                    <div class="page--wrapper-contest">
                      <div class="container">
                        <div class="row">
                          <div class="col-lg-3 col-12"></div>
                
                          <div class="col-lg-6 col-12">
                            <div class="page--block">
                              <div class="page--block-header" v-bind:style="{ 'background-image': 'url(' + editted.backgroundUrl + ')',}">
                                <div class="page--block-header-logo" v-bind:style="{ 'background-image': 'url(' + editted.logoUrl + ')',}"></div>
                              </div>
                              <div class="page--block-content">
                                <div class="page--block-title" v-bind:style="{color: editted.primaryColor,}">{{editted.title}}</div>
                                <p class="page--block-description" v-bind:style="{color: editted.textColor,}" v-if="editted.description != null" v-html="editted.description.replace(new RegExp('\r?\n','g'), '<br />')">
                                </p>
                                <strong class="page--block-description" v-bind:style="{color: editted.secondaryColor,}">
                                  Track Details
                                </strong>
                                <p class="page--block-description" v-bind:style="{color: editted.textColor,}">
                                  {{ editted.trackArtist }} - {{ editted.trackName }}
                                </p>
                
                                <div class="page--block-button"  v-bind:style="{background: editted.primaryColor,}">Download Stems</div>
                              </div>
                            </div>
                            <div class="countdown--block" v-if="editor.mode == 'notOpen'">
                              <div class="container">
                                <div class="row">
                                  <div class="col-lg-2 col-12">
                                    <svg version="1.1" class="countdown--lock" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                                      <g>
                                        <g>
                                          <path d="M437.333,192h-32v-42.667C405.333,66.99,338.344,0,256,0S106.667,66.99,106.667,149.333V192h-32
                                    C68.771,192,64,196.771,64,202.667v266.667C64,492.865,83.135,512,106.667,512h298.667C428.865,512,448,492.865,448,469.333
                                    V202.667C448,196.771,443.229,192,437.333,192z M287.938,414.823c0.333,3.01-0.635,6.031-2.656,8.292
                                    c-2.021,2.26-4.917,3.552-7.948,3.552h-42.667c-3.031,0-5.927-1.292-7.948-3.552c-2.021-2.26-2.99-5.281-2.656-8.292l6.729-60.51
                                    c-10.927-7.948-17.458-20.521-17.458-34.313c0-23.531,19.135-42.667,42.667-42.667s42.667,19.135,42.667,42.667
                                    c0,13.792-6.531,26.365-17.458,34.313L287.938,414.823z M341.333,192H170.667v-42.667C170.667,102.281,208.948,64,256,64
                                    s85.333,38.281,85.333,85.333V192z" />
                                        </g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                      <g>
                                      </g>
                                    </svg>
                                  </div>
                                  <div class="col-lg-10 col-12">
                                    <div class="container-fluid">
                                      <!--<div class="row">
                                        <div class="col-lg-3 col-12">
                                          <span class="countdown--int">{{openingIn.d}}</span>
                                          <span class="countdown--label">Days</span>
                                        </div>
                                        <div class="col-lg-3 col-12">
                                          <span class="countdown--int">{{openingIn.h}}</span>
                                          <span class="countdown--label">Hours</span>
                                        </div>
                                        <div class="col-lg-3 col-12">
                                          <span class="countdown--int">{{openingIn.m}}</span>
                                          <span class="countdown--label">Minutes</span>
                                        </div>
                                        <div class="col-lg-3 col-12">
                                          <span class="countdown--int">{{openingIn.s}}</span>
                                          <span class="countdown--label">Seconds</span>
                                        </div>
                                      </div>-->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form--block" v-if="editor.mode == 'open'">
                              <div class="container-fluid container--no-margin">
                                <div class="page--form-content">
                                <div class="row row--spacing">
                                  <div class="col-xs-12 col-sm-12 col-lg-6">
                                    <div class="page--input-label">Artist Name</div>
                                    <input type="text" placeholder="Artist" name="title"  class="input--text email login--input-bottom" />
                                  </div>
                                  <div class="col-xs-12 col-sm-12 col-lg-6">
                                    <div class="page--input-label">Track Title</div>
                                    <input type="text" placeholder="Title" name="title"  class="input--text email login--input-bottom" />
                                  </div>
                                </div>
                                <div class="row row--spacing">
                                  <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <div class="page--input-label">Email</div>
                                    <input type="text" placeholder="E-mail Address" name=""  class="input--text email login--input-bottom" />
                                  </div>
                                </div>
                                <hr />
                                <div class="row">
                                  <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <div class="page--input-label">How would you like to deliver your demo?</div>
                                    <select class="input--select" v-model="demo.type">
                                      <option value="soundcloud">Soundcloud</option>
                                      <option value="dropbox">Dropbox</option>
                                      <option value="file">MP3 / WAV</option>
                                    </select>
                                  </div>
                                </div>
                                <hr />
                                <div class="row row--spacing" v-if="demo.type == 'soundcloud'">
                                  <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <div class="page--input-label">Soundcloud URL</div>
                                    <input type="text" v-model="demo.soundcloud_url" placeholder="https://soundcloud.com/user/trackname" name="" class="input--text email login--input-bottom" />
                                  </div>
                                </div>
                                <div class="row row--spacing" v-if="demo.type == 'dropbox'">
                                  <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <div class="page--input-label">Dropbox URL</div>
                                    <input type="text" v-model="demo.dropbox_url" placeholder="Dropbox URL" name="" class="input--text email login--input-bottom" />
                                  </div>
                                </div>
                                <div class="row row--spacing" v-if="demo.type == 'file'">
                                  <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <div id="drop_zone"  class="input--drop" v-cloak @drop.prevent="addFile" @dragover.prevent>
                                      <p class="input--drop-text"><strong>Drag </strong> a file here..</p>
                                      <svg version="1.1" class="input--drop-icon" viewBox="0 0 408 408" style="enable-background:new 0 0 408 408;" width="75" xml:space="preserve">
                                        <g>
                                          <g>
                                            <path d="M332,121.921H184.8l-29.28-34.8c-0.985-1.184-2.461-1.848-4-1.8H32.76C14.628,85.453,0,100.189,0,118.321v214.04
                c0.022,18.194,14.766,32.938,32.96,32.96H332c18.194-0.022,32.938-14.766,32.96-32.96v-177.48
                C364.938,136.687,350.194,121.943,332,121.921z" />
                                          </g>
                                        </g>
                                        <g>
                                          <g>
                                            <path d="M375.24,79.281H228l-29.28-34.8c-0.985-1.184-2.461-1.848-4-1.8H76c-16.452,0.027-30.364,12.181-32.6,28.48h108.28
                c5.678-0.014,11.069,2.492,14.72,6.84l25,29.72H332c26.005,0.044,47.076,21.115,47.12,47.12v167.52
                c16.488-2.057,28.867-16.064,28.88-32.68v-177.48C407.957,94.1,393.34,79.413,375.24,79.281z" />
                                          </g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                      </svg>
                                    </div>
                
                                    <div class="overview--files">
                                      <ul>
                                        <li v-for="file in demo.files" v-bind:key="file">
                                          {{ file.name }} ({{ file.size | kb }} kb) <button @click="removeFile(file)" title="Remove">x</button>
                                        </li>
                                      </ul>
                                    </div>
                                    </div>
                                  </div>
                                                        <hr />
                                <div class="row row--spacing">
                                  <div class="col-xs-12 col-sm-12 col-lg-12">
                                    <button class="submit-button" v-bind:style="{
                                      background: editted.secondaryColor,
                                      }" @click="submit()">
                                      Submit
                                    </button>
                                    <a href="https://contestcrate.com"><img src="/img/Powered.png" class="form--powered" /></a>
                                  </div>
                                </div>
                              </div></div>
                            </div>

                          </div>
                          <div class="col-lg-3 col-12"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
//import Tabs from "../components/Tabs";
//import Tab from "../components/Tab";
import ColorPicker from "../components/ColorPicker";
import Datepicker from 'vuejs-datepicker';
export default {
  name: "pageeditor",
  components: {
    Loading,
    //Tabs,
    //Tab,
    picker: ColorPicker,
    Datepicker,
  },
  data() {
    return {
      page_id: this.$route.params.id,

      isLoading: false,
      fullPage: true,
      disabledDatesOpen: {
        to: new Date(Date.now() - 8640000)
      },
      page: null,
      editted: null,
      demo: {
        type: 'file',
      },
      editor: {
        mode: "open"
      },
    };
  },
  mounted() {
    this.getPage();
    console.log(this.page.primaryColor);
  },
  methods: {
    getPage() {
      var self = this;
      this.isLoading = true;
      axios({
        method: "GET",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "https://api.contestcrate.com/contest/show/" + self.page_id,
      })
        .then(function (response) {
          self.page = response.data;
          self.editted = self.trueCopy(self.page);
          self.editted.startDate = self.timeConverter(self.editted.startDate);
          self.editted.endDate = self.timeConverter(self.editted.endDate);
          self.isLoading = false;
          console.log(self.page);
          console.log(this.page.primaryColor);
        })
        .catch(function (error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
        
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
  
        /*var months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];*/
        //var year = a.getFullYear();
        //var month = months[a.getMonth()];
        //var date = a.getDate();
        //var time = date + " " + month + " " + year + " ";
        return a;
    },
    expand(event) {
      console.log(event.target.parentNode.children[1]);
      if (
        !event.target.parentNode.children[1].classList.contains(
          "page-editor--side-item-content-active"
        )
      ) {
        event.target.parentNode.children[1].classList.add(
          "page-editor--side-item-content-active"
        );
        event.target.parentNode.children[0].children[0].classList.add("active");
      } else {
        event.target.parentNode.children[1].classList.remove(
          "page-editor--side-item-content-active"
        );
        event.target.parentNode.children[0].children[0].classList.remove(
          "active"
        );
      }
    },
    clipboard(evt) {
      evt.preventDefault();
      navigator.clipboard.writeText(evt.target.getAttribute("href")).then(
        () => {
          /* clipboard successfully set */
        },
        () => {
          /* clipboard write failed */
        }
      );
    },
    trueCopy(o) {
      return Object.assign(new Object(), o);
    },      
    changeAssets(event, type){
      var file = event.target.files[0];
      var reader = new FileReader();
      if(type == "logo"){
        reader.onloadend = function () {
          document.getElementById("preview--logo").style.backgroundImage = 'url("' + reader.result + '")';
          document.getElementById("preview--form-logo").style.backgroundImage = 'url("' + reader.result + '")';
        }
        if (file) {
            reader.readAsDataURL(file);
        } else {
          console.log("no file");
        }
        
      }else{
        reader.onloadend = function () {
          document.getElementById("preview--background").style.backgroundImage = 'url("' + reader.result + '")';
          document.getElementById("preview--form-background").style.backgroundImage = 'url("' + reader.result + '")';
        }
        if (file) {
            reader.readAsDataURL(file);
        } else {
          console.log("no file");
        }
      }
      
    },
    uploadAssets() {
      var formData = new FormData();
      var logo = document.querySelector('#file-logo');
      var background = document.querySelector('#file-background');
      console.log(logo);
      console.log(background);
      this.isLoading = true;
      var self = this;
      formData.append("organization_id", this.$globals.organization_id);
      
      if (logo.files[0]){
        formData.append("logoImage",  logo.files[0]);
      }
      
      if (background.files[0]){
        formData.append("backgroundImage",  background.files[0]);
      }
    
      formData.append("enabled", this.editted.enabled);
      formData.append("public",  1);
      
      axios.post("/contest/update/" + self.editted.customUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })        
      .then(function (response) {
        console.log(response);
        self.$globals.getPages();
        self.isLoading = false;
      });
    },
    publish() {
      let self = this;
      this.isLoading = true;
      this.uploadAssets();
      this.editted.startDate = new Date(this.editted.startDate).getTime() / 1000;
      this.editted.endDate = new Date(this.editted.endDate).getTime() / 1000;
      self.editted.public = 1;
      axios({
        method: "POST",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "/contest/update/" + self.editted.customUrl,
        data: self.editted,
      })
        .then(function (response) {
          console.log(response);
          self.isLoading = false;
          self.getPage();
          self.$globals.getContests();
        })
        .catch(function (error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });
    },
    test(e) {
      console.log(e);
    },
  },
};
</script>